import React, { Component } from "react";
import ReactDOM from "react-dom";
import axios from "axios";
import { getErrorsMessage, getSuccessMessage } from '../utils.js';
import BillingCycleSwitch from "./BillingCycleSwitch.jsx";
import { LangContext } from "../LangContext.jsx";
class Pricing extends Component {
    constructor(props) {
        super();
        this.state = {
            upgradeBillingPlan:false,
            billingCycle: "months",
            billingPlans: [],
            zohoUrl: "/api/zoho/hosted-page/subscriptions",
            subscription: []
        };
    }

    componentDidMount() {
        this.getBillingPlans();
    }

    getBillingPlans(billingCycle = "months") {
        axios.get(`/api/billing-plans?interval_unit=${billingCycle}`)
            .then((res) => {
                console.log(res.data);
                this.setState({ billingPlans: res.data.billingPlans });
                this.setState({ subscription: res.data.subscription });
                this.setState({ upgradeBillingPlan:res.data.upgradeBillingPlan });
                if(this.state.subscription.billing_plan_id > 7){
                    location.href = '/additional_plans';
                }
                console.log(res.data.subscription);
                if(this.state.upgradeBillingPlan){
                    this.setState({zohoUrl:'/api/zoho/hosted-page/subscriptions/'  + res.data.subscription.id  });
                }
            });
    }

    generateHostedPage = (code) => {
        window.blockUI();
        const method = this.state.zohoUrl.includes('/subscriptions/') ? 'patch' : 'post';
        axios[method](this.state.zohoUrl, { plan_code: code })
            .then((res) => {
                window.unblockUI();
                const { success, data } = res.data;
                if (success && data?.hostedpage?.url) {
                    window.location.href = data.hostedpage.url;
                } else {
                    console.error(
                        "Error: No se encontró la URL de la página alojada."
                    );
                    alert(
                        "No se pudo redirigir a la página de compra. Por favor, intenta nuevamente."
                    );
                }
            })
            .catch((err) => {
                console.error("Error al generar la página alojada:", err);
                alert(
                    "Ocurrió un error al procesar tu solicitud. Por favor, intenta nuevamente."
                );
            });
    };

    setBillingCycle(billingCycle) {
        this.setState({ billingCycle }, () => {
            this.getBillingPlans(billingCycle);
        });
    }
    gotoUrl = (url) => {
        window.location = url;
    }
    render() {
        const { billingPlans, subscription } = this.state;
        return (
            <>
                <div className="text-center my-4">
                    <h1 style={{ color: "black", fontWeight: "bold" }}>
                        Elige tu plan paras la empresa
                    </h1>
                    <p className="text-primary font-size-h4 ">{this.props.person.name}</p>
                    <p className="text-muted">RFC: ( {this.props.person.rfc})  </p>
                    <p className="text-muted" style={{ fontSize: "14px" }}>
                        Selecciona el plan que se acomode mejor a tus
                        necesidades
                    </p>
                </div>
                <BillingCycleSwitch
                    billingCycle={this.state.billingCycle}
                    setBillingCycle={this.setBillingCycle.bind(this)}
                />
                <div className="text-center my-4">
                    <p style={{ fontSize: "14px", color: "#677177" }}>
                        Gestiona recurrencias en la solicitud de documentos, <br></br>
                        datos, valida y mantén expedientes actualizados
                    </p>
                </div>
                <div className="container d-flex">
                    {this.state.billingPlans.map((plan) => {
                        const isEligible = this.state.upgradeBillingPlan === false || plan.id > subscription?.billing_plan_id;

                        return (
                        <div
                            key={plan.id}
                            className={` m-5 flex-fill d-flex flex-column ${isEligible ? 'pricing-plan' : 'pricing-plan-disabled'}`}
                            style={{ minHeight: "600px" }} // Altura mínima opcional como respaldo
                        >
                            <div  className={" p-4 "}
                                style={{ 
                                    color: "white",
                                    textAlign: "center",
                                    backgroundColor: "#25145e",
                                }}
                            >
                                <h3><strong>{plan.name.toUpperCase()}</strong></h3>
                            </div>
                            <div className="p-4 flex-grow-1">
                                <p
                                    style={{
                                        fontSize: "24px",
                                        fontWeight: "bold",
                                        color: "#25145e",
                                        textAlign: "center",
                                    }}
                                >
                                    {plan.is_free ? (
                                        "GRATIS"
                                        ) : (
                                        <>
                                            ${parseInt(plan.price).toLocaleString()}<sup>00</sup>
                                            <span style={{ fontSize: '14px', fontWeight: 'normal', color: '#25145e' }}>
                                                {" "}MXN / AÑO
                                            </span>
                                            <div style={{ fontSize: '12px', fontWeight: 600, color: '#25145e' }}>
                                                {this.state.billingCycle === 'months' ? 'FACTURADO MENSUALMENTE' : 'FACTURADO ANUALMENTE'}
                                            </div>
                                        </>
                                        )}
                                </p>
                                <p className="text-muted">{plan.description}</p>
                                <div className="divider-pricing"></div>
                                <ul className="list-unstyled">
                                    {plan.features.map((feature, index) => (
                                        <li key={index} className="d-flex align-items-start mb-2">
                                            <i
                                                className="flaticon2-check-mark mr-3 mt-1 flex-shrink-0"
                                                style={{
                                                    width: '18px',
                                                    height: '18px',
                                                    borderRadius: '50%',
                                                    backgroundColor: '#13c1ff',
                                                    color: '#fff',
                                                    display: 'inline-flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                    fontSize: '10px',
                                                    lineHeight: 1,
                                                }}
                                            ></i>
                                            <span className="align-text-top">
                                                {feature.description}
                                            </span>
                                        </li>
                                    ))}
                                </ul>

                            </div>
                            <div className="mt-auto p-4">
                                {plan.has_additional_plans ? (
                                    <a
                                        href={`/additional_plans`}
                                        className="btn btn-block"
                                        style={{ backgroundColor: '#915cff', borderColor: '#915cff', borderRadius: '30px', color: '#ffffff' }}
                                    >
                                        <strong>Ver planes</strong>
                                    </a>
                                ) : (
                                    <button
                                        className="btn btn-block"
                                        style={{ backgroundColor: '#915cff', borderColor: '#915cff', borderRadius: '30px', color: '#ffffff' }}
                                        disabled={!isEligible}
                                        onClick={() =>
                                            this.generateHostedPage(
                                                plan.zoho_plan_code
                                            )
                                        }
                                    >
                                        <strong>Contratar</strong>
                                    </button>
                                )}
                            </div>
                        </div>
                    )})}
                    <div
                        className="pricing-plan m-5 flex-fill d-flex flex-column"
                        style={{ minHeight: "600px", minWidth: "200px" }} // Altura mínima opcional como respaldo
                    >
                        <div
                            className="p-4"
                            style={{ 
                                color: "white",
                                textAlign: "center",
                                backgroundColor: "#25145e",
                            }}
                        >
                            <h3><strong>ENTERPRISE</strong></h3>
                        </div>
                        <div className="p-4 flex-grow-1">
                            <strong>
                                Paquete en base a tus necesidades de usuarios y
                                expedientes.
                            </strong>
                            <br></br> <br></br>
                            <p className="text-muted">
                                {" "}
                                Personaliza tu cuenta según las necesidades de
                                tu empresa
                            </p>
                            <div className="divider-pricing"></div>
                            <ul className="list-unstyled">
                                <li className="d-flex align-items-start mb-2">
                                    <i
                                        className="flaticon2-check-mark mr-3 mt-1 flex-shrink-0"
                                        style={{
                                            width: '18px',
                                            height: '18px',
                                            borderRadius: '50%',
                                            backgroundColor: '#13c1ff',
                                            color: '#fff',
                                            display: 'inline-flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            fontSize: '10px',
                                            lineHeight: 1,
                                        }}
                                    ></i>
                                    <span className="align-text-top">
                                        Soporte Premium
                                    </span>
                                </li>
                                <li className="d-flex align-items-start mb-2">
                                    <i
                                        className="flaticon2-check-mark mr-3 mt-1 flex-shrink-0"
                                        style={{
                                            width: '18px',
                                            height: '18px',
                                            borderRadius: '50%',
                                            backgroundColor: '#13c1ff',
                                            color: '#fff',
                                            display: 'inline-flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            fontSize: '10px',
                                            lineHeight: 1,
                                        }}
                                    ></i>
                                    <span className="align-text-top">
                                        Entorno dedicado
                                    </span>
                                </li>
                            </ul>
                        </div>
                        <div className="mt-auto p-4">
                            <a href="mailto:info@detecno.com" className="btn btn-block" style={{ backgroundColor: '#915cff', borderColor: '#915cff', borderRadius: '30px',color: '#ffffff' }}>
                                <strong>Contactar</strong> 
                            </a>
                        </div>
                    </div>
                </div>

                <div  className="text-center my-4">
                    {this.state.upgradeBillingPlan && (
                        <button className="btn btn-success m-5" onClick={() => this.gotoUrl('/')}>
                            Regresar a mi panel de cliente
                        </button>
                    )}
                    {!this.state.upgradeBillingPlan && (
                        <button className="btn btn-success m-5" onClick={()=>{this.gotoUrl('/provider')}}>Continuar como invitado</button>
                    )}
                    {this.props.peoplecount > 1 && <button className="btn btn-success m-5" onClick={()=>{this.gotoUrl('/company/select')}}>Cambiar de empresa</button>}
                </div>
            </>
        );
    }
}

export default Pricing;

if (document.getElementById("Pricing")) {
    ReactDOM.render(<Pricing />, document.getElementById("Pricing"));
}
